module.exports = __webpack_public_path__ + "img/plFai.0519eb26.svg";